/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 12/01/2025
 * @update 12/01/2025
 * @file src/components/W17/W05F1424
 */

import { Column } from "devextreme-react/data-grid";
import { Checkbox, Col, DatePicker, Dropdown, NumberInput, Row, TextInput, ButtonIcon } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W05F1424Actions from "../../../actions/w05/w05F1424/w05F1424-actions";
import Config from "../../../config";
import MForm from "../../common/form/form";
import GridActionBar from "../../common/action-bar/grid-action-bar-hover";
import GridContainer from "../../common/grid-container/grid-container";
import W2W from "../../common/w2w/index";

const FormID = 'W05F1424';
const initialDataMaster = {
    DateFrom: null,
    DateTo: null,
    DeliveryNum: null,
    DiscountID: '',
    DiscountName: '',
    DiscountTypeID: '',
    DiscountTypeName: '',
};
const requiredArr = ['DiscountID'];
const defaultRowGridRight = [{
    STT: 0,
    DiscountValue: null,
    InventoryID: '',
    InventoryName: '',
    UnitID: '',
    UnitName: '',
    DiscountTypeID: '',
    DiscountTypeName: '',
}];

const W05F1424 = (props) => {
    const [mode, _setMode] = useState('view'); // Mặc định mode View
    const [isChangeForm, setIsChangeForm] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [cboDiscountTypeLoading, setCboDiscountTypeLoading] = useState(false);
    const [error, setError] = useState({});
    const [dataMaster, setDataMaster] = useState({ ...initialDataMaster });
    const [dataCboDiscountType, setDataCboDiscountType] = useState([]);
    const [dataCboInventory, setDataCboInventory] = useState([]);
    const [dataGridRight, setDataGridRight] = useState([{ ...defaultRowGridRight[0] }]);
    //===================useRef====================
    const w2wRef = useRef(null);
    const gridRightRef = useRef(null);
    const modeRef = useRef(mode);
    const readOnly = modeRef.current === 'view';

    useEffect(() => {
        loadDataGeneral('DiscountType');
        loadDataGeneral('Inventory');
        loadDataGeneral('Unit');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (mode === 'add') onNext();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);

    const loadDataGeneral = (modeLoad, paramPlus, cb) => {
        gridParam(modeLoad, true);
        props.W05F1424Actions.loadForm(gridParam(modeLoad, false, paramPlus), (err, data) => {
            gridParam(modeLoad, false);
            if (cb) return cb(err, data);
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                gridParam(modeLoad, data);
            }
        });
    };

    const getModeParam = (mode = modeRef.current) => {
        let result = 0;
        switch (mode) {
            case 'edit':
            case 'view':
                result = 1;
                break;
            case 'copy':
                result = 2;
                break;
            default:
                break;
        }
        return result;
    };

    const gridParam = (type, status, paramPlus) => {
        let DataTypeID = '';
        const result = {
            FormID,
            Mode: 0,
            DiscountID: '',
            StrSearch: ''
        };
        switch (type) {
            case 'DiscountType':
                DataTypeID = 'LoadcmbDiscountType';
                if (!Config.typeOf(status, 'undefined')) {
                    if (Config.typeOf(status, 'boolean')) setCboDiscountTypeLoading(status);
                    else setDataCboDiscountType(status);
                }
                break;
            case 'Inventory':
                DataTypeID = 'LoadcmbInv';
                if (Config.typeOf(status, 'array')) setDataCboInventory(status || []);
                break;
            case 'Unit':
                DataTypeID = 'LoadcmbUnitID';
                if (paramPlus) result.StrSearch = paramPlus.InventoryID || '';
                break;
            case 'loadGrid':
                delete result.StrSearch;
                DataTypeID = 'LoadForm_1';
                break;
            case 'loadForm':
                if (paramPlus) result.DiscountID = paramPlus.DiscountID;
                DataTypeID = 'LoadForm_2';
                result.Mode = getModeParam();
                if (!Config.typeOf(status, 'undefined')) {
                    if (Config.typeOf(status, 'boolean')) setFormLoading(status);
                    else {
                        const { master = {}, detail = [] } = status || {};
                        setDataMaster(master);
                        let dataDetail = detail;
                        if (modeRef.current !== 'view') dataDetail = [...dataDetail, { ...defaultRowGridRight[0] }];
                        setDataGridRight(dataDetail.map((item, idx) => ({ ...item, STT: idx })));
                    }
                }
                break;
            case 'isUsed':
                DataTypeID = 'Disabled';
                break;
            case 'delete':
                DataTypeID = 'Delete';
                break;
            case 'save':
                delete result.Mode;
                DataTypeID = 'Save';
                break;
            default:
                break;
        }
        result.DataTypeID = DataTypeID;
        return result
    };

    const setDataMasterState = (obj = {}) => {
        setDataMaster({ ...dataMaster, ...obj });
    };

    const onChangeRow = (data = {}) => {
        if (!Config.isEmpty(data)) {
            loadDataGeneral('loadForm', data);
        }
        setError({});
        setIsChangeForm(false);
    };

    const onNext = () => { // Clear Form
        setError({});
        setIsChangeForm(false);
        setDataMaster({ ...initialDataMaster }); // set lại default
        setDataGridRight([{ ...defaultRowGridRight[0] }]);
    };

    const renderIsDisabledColumn = (e) => {
        const value = e?.data?.Disabled ?? 0;
        return <Checkbox
            readOnly
            style={{ margin: 'auto' }}
            className={'flex valign-middle'}
            checked={!!value}
        />;
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            return {
                name: item,
                rules: ['isRequired'],
                value: dataMaster[item]
            }
        });
    };

    const onSave = async (filter) => {
        const resultValidate = checkValidateMaster(requiredArr);
        const validateForm = MForm.formValidation(resultValidate);
        if (Object.keys(validateForm).length > 0) {
            setError(validateForm);
            return false;
        } else {
            await gridRightRef.current.instance.saveEditData();
            const dataSource = gridRightRef.current.instance.option('dataSource') || [];
            const params = {
                ...filter,
                ...dataMaster,
                data: JSON.stringify(dataSource),
                Mode: getModeParam(filter?.Mode)
            };
            return {
                params,
                mode: mode,
                cb: () => {
                    setIsChangeForm(false);
                }
            };
        }
    };

    const handleChangeGridRight = async (dataSource, dataObjChange = {}) => {
        const newDataGridRight = dataSource.map((item, index) => {
            let result = { ...item, STT: index };
            if (index + 1 !== dataSource.length) result = { ...result, ...dataObjChange };
            return result;
        });
        setDataGridRight(newDataGridRight);
    };

    const onChange = async (fieldName, e, isWarning = true) => {
        if (Config.isEmpty(fieldName)) return;
        let objPlus = {};
        let value = (Config.typeOf(e, 'object') ? e?.value ?? e?.target?.value : e) ?? '';
        if (Config.typeOf(value, 'boolean')) value = +value;
        if (!Config.typeOf(initialDataMaster[fieldName], 'string') && Config.isEmpty(value)) value = null;
        switch (fieldName) {
            case 'DiscountTypeID':
                const name = fieldName.replace('ID', 'Name');
                const { [name]: fieldNameVal = '' } = e?.data || {};
                await gridRightRef.current.instance.saveEditData();
                const dataSource = gridRightRef.current.instance.option('dataSource') || [];
                if (dataSource.length > 1 && isWarning) {
                    Config.popupCore.show('YES_NO', `${Config.lang('Cap_nhat_lai_mot_so_thong_tin_mat_hang_khi_chon')}, ${Config.lang('Ban_co_muon_chon_lai_khong')}`, () => {
                        handleChangeGridRight(dataSource, { [fieldName]: value, [name]: fieldNameVal, DiscountValue: null });
                        onChange(fieldName, e, false);
                    });
                    return;
                }
                objPlus = { ...objPlus, [name]: fieldNameVal };
                break;
            default:
                break;
        }
        objPlus = { ...objPlus, [fieldName]: value };
        setIsChangeForm(true);
        setDataMasterState(objPlus);
        if (error[fieldName] && value) setError({ ...error, [fieldName]: '' });
    };

    const renderNumberFormat = (e) => {
        if (!e) return false;
        let propPlus = {};
        if (dataMaster?.DiscountTypeID === 'Rate') propPlus = { min: -100, max: 100 };
        return <NumberInput
            nonStyle
            readOnly={readOnly}
            maxDigit={28}
            decimalDigit={8}
            thousandSeparator={','}
            inputStyle={{ textAlign: 'right' }}
            value={e?.value}
            onChange={(c) => {
                let val = c?.value ?? null;
                if (val > propPlus.max) val = propPlus.max;
                else if (val < propPlus.min) val = propPlus.min;
                e.setValue(val);
            }}
            {...propPlus}
        />
    };

    const renderDDColumn = (e) => {
        let dataSource = [];
        let props = {};
        const { dataField } = e?.column || {};
        let displayName = dataField;
        if (dataField.includes('ID')) displayName = dataField.replace('ID', 'Name');
        let displayExpr = displayName;
        switch (dataField) {
            case 'UnitID':
                props = {
                    action: {
                        loadData: (params, cb) => loadDataGeneral('Unit', e?.data, cb)
                    }
                };
                break;
            case 'InventoryID':
                dataSource = dataCboInventory;
                displayExpr = `{${dataField}} - {${displayName}}`;
                break;
            default:
                break;
        }
        return <Dropdown
            valueExpr={dataField}
            displayExpr={displayExpr}
            viewType={'none'}
            value={e.value}
            valueObjectDefault={e.value ? {
                [dataField]: e?.value || '',
                [displayName]: e?.data?.[displayName] || '',
            } : null}
            onChange={(c) => {
                const { [displayName]: name, UnitID = '', UnitName = '' } = c?.data;
                e.component.cellValue(e.rowIndex, dataField, c?.value);
                e.component.cellValue(e.rowIndex, displayName, name);
                if (dataField === 'InventoryID') {
                    e.component.cellValue(e.rowIndex, "UnitID", UnitID);
                    if (Object.hasOwn(c?.data ?? {}, 'UnitName')) e.component.cellValue(e.rowIndex, "UnitName", UnitName);
                }
                e.setValue(c.value);
                e.component.saveEditData();
            }}
            {...(props?.action ? { action: props.action } : { dataSource })}
            {...props}
        />
    };

    const deleteRow = (e) => {
        if (!e) return;
        Config.popupCore.show('YES_NO', Config.lang('Ban_co_chac_muon_xoa?'), async () => {
            e.component.deleteRow(e.rowIndex);
            const dataSource = e.component.option('dataSource') || [];
            setDataGridRight(dataSource.map((item, index) => ({ ...item, STT: index })));
            setIsChangeForm(true);
        });
    };

    const renderActionGridRight = (e) => {
        return (
            <GridActionBar>
                <ButtonIcon
                    circular
                    disabled={readOnly || e?.rowIndex + 1 === dataGridRight.length}
                    name={'Delete'}
                    size={'small'}
                    viewType={'text'}
                    onClick={() => deleteRow(e)} />
            </GridActionBar>
        );
    };

    const renderGridRight = useMemo(() => {
        return (
            <GridContainer
                reference={ref => (gridRightRef.current = ref)}
                dataSource={dataGridRight}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={50}
                listPerPage={[50, 100, 150, 200]}
                elementAttr={{ style: 'min-height: 420px' }}
                onRowUpdated={(e) => {
                    const { STT, InventoryID } = e?.data || {};
                    if (STT + 1 === dataGridRight.length && !Config.isEmpty(InventoryID)) {
                        const dataGrid = e.component.option('dataSource') || [];
                        if (!Config.isEmpty(dataMaster.DiscountTypeID)) {
                            dataGrid[dataGrid.length - 1]['DiscountTypeID'] = dataMaster.DiscountTypeID;
                            dataGrid[dataGrid.length - 1]['DiscountTypeName'] = dataMaster.DiscountTypeName;
                        }
                        setDataGridRight([...dataGrid, { ...defaultRowGridRight[0], STT: dataGridRight.length }]);
                    }
                    setIsChangeForm(true);
                }}
                onInitNewRow={(eMethod) => {
                    const arrKeys = Object.keys(defaultRowGridRight[0]);
                    for (let i = 0; i < arrKeys.length; i++) {
                        eMethod.data[arrKeys[i]] = defaultRowGridRight[0][arrKeys[i]];
                    }
                }}
                sorting={{
                    mode: 'none'
                }}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: !readOnly,
                    texts: { confirmDeleteMessage: '' },
                    startEditAction: 'click',
                }} >
                <Column
                    fixed
                    width={90}
                    allowEditing={false}
                    allowSorting={false}
                    cellRender={renderActionGridRight}
                    caption={Config.lang('Hanh_dong')}
                    alignment={'center'}
                    visible={Config.isMobile && mode !== 'view'} />
                <Column
                    width={280}
                    dataField={'InventoryID'}
                    caption={Config.lang('Ma_hang')}
                    editCellRender={renderDDColumn}
                />
                <Column
                    allowEditing={false}
                    dataField={'InventoryName'}
                    caption={Config.lang('Ten_hang')}
                />
                <Column visible={false} dataField={'UnitName'} />
                <Column
                    width={200}
                    dataField={'UnitID'}
                    caption={Config.lang('Don_vi_tinh')}
                    editCellRender={renderDDColumn}
                    calculateDisplayValue={e => e?.UnitName}
                />
                <Column visible={false} dataField={'DiscountTypeID'} />
                <Column
                    width={160}
                    allowEditing={false}
                    dataField={'DiscountTypeName'}
                    caption={Config.lang('Phuong_thuc')}
                />
                <Column
                    width={160}
                    dataField={'DiscountValue'}
                    caption={Config.lang('Gia_tri')}
                    editCellRender={renderNumberFormat}
                    calculateDisplayValue={e => Config.numberFormat(e?.DiscountValue, 8)}
                />
                <Column allowEditing={false} width={50} fixed alignment={"right"} fixedPosition={"right"} visible={!Config.isMobile && mode !== 'view'} cellRender={renderActionGridRight} />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGridRight, dataCboInventory, dataMaster?.DiscountTypeID, dataMaster?.DiscountTypeName, readOnly, mode]);

    const handleLoadAction = (params, cb, paramMode) => {
        let apiName = 'loadForm';
        const { Mode, ...restParam } = params || {};
        const paramAction = { ...gridParam(paramMode), ...restParam };
        if (paramMode === 'save') apiName = 'save';
        else if (['delete', 'isUsed'].includes(paramMode)) apiName = 'deleteRow';
        if (Config.typeOf(Mode, 'string')) paramAction.Mode = getModeParam(Mode);
        if (!Object.hasOwn(paramAction ?? {}, 'Mode')) paramAction.Mode = Mode;
        return props.W05F1424Actions?.[apiName](paramAction, (err, data) => {
            cb && cb(err, data);
        })
    };

    const setMode = (mode, isSameRow) => {
        const dataSource = gridRightRef.current.instance.option('dataSource') || [];
        if (isSameRow && mode !== 'view') setDataGridRight([...dataSource, { ...defaultRowGridRight[0], STT: dataGridRight.length }]); // Add thêm dòng nếu từ mode view sang mode khác
        modeRef.current = mode;
        _setMode(modeRef.current);
    };

    return (
        <W2W
            ref={w2wRef}
            FormID={FormID} // FormID của màn hình để truyền vào params của các API phân quyền, Lưu lịch sử checkbox disabled, xóa
            isChanged={isChangeForm} // State quản lý dữ liệu cột bên phải đã thay đổi
            mode={mode}
            updateMode={setMode}
            checkboxHidden
            action={{
                loadGrid: (params, cb) => handleLoadAction(params, cb, 'loadGrid'), // action load lưới trái
                add: (params, cb) => handleLoadAction(params, cb, 'save'), // action save thêm dòng mới
                edit: (params, cb) => handleLoadAction(params, cb, 'save'), // action save sửa dòng
                copy: (params, cb) => handleLoadAction(params, cb, 'save'), // action save copy dòng
                delete: (params, cb) => handleLoadAction(params, cb, 'delete'), // action xóa dòng
                isUsed: (params, cb) => handleLoadAction(params, cb, 'isUsed'), // action sử dụng
            }}
            actionToolbar={{ // title của ActionToolbar 
                title: Config.lang('Danh_sach_chinh_sach_gia'),
            }}
            titleRight={Config.lang('Chi_tiet_chinh_sach_gia')}
            onSelectedRow={onChangeRow}
            keyExpr={'DiscountID'}
            onSave={onSave} // Xử lý sự kiện lưu
            loading={formLoading}
            leftCol={{ // Số cột hiển thị của lưới bên trái
                xs: 12,
                sm: 12,
                md: 5,
                lg: 5,
            }}
            dataColumnGrid={[ // Các cột của lưới trái 
                {
                    width: 200,
                    dataField: 'DiscountID',
                    caption: Config.lang('Ma_chinh_sach'),
                },
                {
                    width: 380,
                    dataField: 'DiscountName',
                    caption: Config.lang('Ten_chinh_sach')
                },
                {
                    width: 120,
                    dataType: 'boolean',
                    dataField: 'Disabled',
                    caption: Config.lang('Khong_su_dung'),
                    trueText: Config.lang('Co'),
                    falseText: Config.lang('Khong'),
                    cellRender: renderIsDisabledColumn,
                    calculateCellValue: (rowData) => !!rowData?.Disabled
                }
            ]}>
            {/* Cột bên phải */}
            <Row>
                <Col xs={12} sm={6} md={6} lg={4} verticalAlign={'end'}>
                    <TextInput
                        required
                        readOnly={readOnly || mode === 'edit'}
                        label={Config.lang('Ma_chinh_sach')}
                        value={dataMaster?.DiscountID}
                        error={error && error['DiscountID']}
                        onChange={e => onChange('DiscountID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} verticalAlign={'end'}>
                    <TextInput
                        readOnly={readOnly}
                        label={Config.lang('Ten_chinh_sach')}
                        value={dataMaster?.DiscountName}
                        onChange={e => onChange('DiscountName', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} verticalAlign={'end'}>
                    <Dropdown
                        clearAble
                        readOnly={readOnly}
                        valueExpr={'DiscountTypeID'}
                        displayExpr={'DiscountTypeName'}
                        loading={cboDiscountTypeLoading}
                        label={Config.lang('Phuong_thuc')}
                        value={dataMaster?.DiscountTypeID}
                        dataSource={dataCboDiscountType || []}
                        onChange={e => onChange('DiscountTypeID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} verticalAlign={'end'}>
                    <DatePicker
                        clearAble
                        label={Config.lang('Thoi_gian_bat_dau')}
                        readOnly={readOnly}
                        displayFormat={"DD/MM/YYYY"}
                        max={dataMaster.DateTo}
                        value={dataMaster.DateFrom}
                        onChange={e => onChange('DateFrom', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} verticalAlign={'end'}>
                    <DatePicker
                        clearAble
                        label={Config.lang('Thoi_gian_ket_thuc')}
                        readOnly={readOnly}
                        displayFormat={"DD/MM/YYYY"}
                        min={dataMaster.DateFrom}
                        value={dataMaster.DateTo}
                        onChange={e => onChange('DateTo', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={4} verticalAlign={'end'}>
                    <NumberInput
                        disabledNegative
                        readOnly={readOnly}
                        value={dataMaster?.DeliveryNum}
                        label={Config.lang('Thoi_gian_giao_hang')}
                        onChange={e => onChange('DeliveryNum', e)}
                    />
                </Col>
                <Col xs={12}>{renderGridRight}</Col>
            </Row>
        </W2W>
    )
};

export default connect(null, (dispatch) => ({
    W05F1424Actions: bindActionCreators(W05F1424Actions, dispatch),
}))(W05F1424);


